import {
  custom,
  managed,
  material,
  org_assessment_icon,
  strategy,
  training,
} from "../../helpers/constant/imageUrl";

export const DIRECT_CARDS = [
  {
    img: "/images/scardd1.webp",
    alt: "Strategic Salesforce consulting",
    title: "Transform Your Business with Our Strategic Salesforce Consulting",
    path: "/services/salesforce-consulting",
  },
  {
    img: "/images/scardd2.webp",
    alt: "Salesforce consulting partner",
    title: "Your Trusted Salesforce Consulting Partner",
    path: "/services/salesforce-consulting",
  },
  {
    img: "/images/scardd3.webp",
    alt: "Salesforce success framework",
    title: "A Proven Framework for Salesforce Success",
    path: "/services/salesforce-consulting",
  },
  {
    img: "/images/scardd4.webp",
    alt: "Why Utilitarian Labs",
    title: "Why Choose Utilitarian Labs",
    path: "/services/salesforce-consulting",
  },
  {
    img: "/images/scardd5.webp",
    alt: "Sales Cloud sales team",
    title: "Powering Your Sales Team with Salesforce Sales Cloud",
    path: "/services/implementation/sales-cloud",
  },
  {
    img: "/images/scardd6.webp",
    alt: "Salesforce integration",
    title: "Our Salesforce Integration Capabilities",
    path: "/services/custom-development/integration-services",
  },
  {
    img: "/images/scardd7.webp",
    alt: "Salesforce support growth",
    title: "Seamless Salesforce Support for Business Growth",
    path: "/services/manages-services/managed-services-support",
  },
  {
    img: "/images/scardd8.webp",
    alt: "Salesforce expert insights",
    title: "Smarter Decisions with Expert Salesforce Insights",
    path: "/services/salesforce-org-assessment",
  },
];

export const SERVICES = [
  {
    text: "Salesforce Consulting & Strategy",
    img: strategy,
    path: "/services/salesforce-consulting",
  },
  {
    text: "Implementation & Deployment",
    img: material,
    segments: [
      {
        text: "Sales Cloud Implementation",
        path: "/services/implementation/sales-cloud",
      },
      {
        text: "Marketing Cloud Implementation",
        path: "/services/implementation/marketing-cloud",
      },
      {
        text: "Service Cloud Implementation",
        path: "/services/implementation/service-cloud",
      },
      {
        text: "Experience Cloud (Community Cloud)",
        path: "/services/implementation/experience-cloud",
      },
      {
        text: "Salesforce DMS Implementation",
        path: "/services/implementation/dms",
      },
      {
        text: "Salesforce Industry Clouds Implementation",
        path: "/services/implementation/industry-clouds",
      },
      {
        text: "Commerce Cloud Implementation",
        path: "/services/implementation/commerce-cloud",
      },
      {
        text: "AI & Einstein Analytics Implementation",
        path: "/services/implementation/ai-einstein",
      },
    ],
    cards: [
      {
        img: "/images/idscard1.webp",
        alt: "Sales Cloud sales team",
        title: "Powering Your Sales Team with Salesforce Sales Cloud",
        path: "/services/implementation/sales-cloud",
      },
      {
        img: "/images/idscard2.webp",
        alt: "Marketing Cloud engagement",
        title: "Turn Marketing Chaos into Customer Connections",
        path: "/services/implementation/marketing-cloud",
      },
      {
        img: "/images/idscard3.webp",
        alt: "Service Cloud customers",
        title: "Next-Gen Customer Service Starts Here",
        path: "/services/implementation/service-cloud",
      },
      {
        img: "/images/idscard4.webp",
        alt: "Experience Cloud (Community Cloud)",
        title: "Trusted Experts in Salesforce Experience Cloud",
        path: "/services/implementation/experience-cloud",
      },
    ],
  },
  {
    text: "Custom Development",
    img: custom,
    segments: [
      {
        text: "Integration Services",
        path: "/services/custom-development/integration-services",
      },
      {
        text: "Data Migration & Management",
        path: "/services/custom-development/data-migration-management",
      },

      {
        text: "Salesforce DevOps & CI/CD",
        path: "/services/custom-development/salesforce-devops-cicd",
      },

      {
        text: "Salesforce Lightning Migration",
        path: "/services/custom-development/lightning-migration",
      },
      {
        text: "Salesforce Testing & QA Services",
        path: "/services/custom-development/testing-qa-services",
      },
    ],
    cards: [
      {
        img: "/images/cdcard1.webp",
        alt: "Salesforce integration",
        title: "Enable Salesforce Integration for Scalable Business Growth",
        path: "/services/custom-development/integration-services",
      },
      {
        img: "/images/cdcard2.webp",
        alt: "Data migration & management",
        title:
          "Expert Implementation for Salesforce Data Migration & Management",
        path: "/services/custom-development/data-migration-management",
      },
      {
        img: "/images/cdcard3.webp",
        alt: "DevOps & CI/CD",
        title: "Simplify Salesforce Releases with DevOps & CI/CD",
        path: "/services/custom-development/salesforce-devops-cicd",
      },
      {
        img: "/images/cdcard4.webp",
        alt: "Salesforce testing & QA",
        title: "Salesforce QA for Seamless, Error-Free Deployments",
        path: "/services/custom-development/testing-qa-services",
      },
    ],
  },

  {
    text: "Salesforce Managed Services",
    img: managed,
    // path: "/services/manages-services",
    segments: [
      {
        text: "Managed Services & Support",
        path: "/services/managed-services/managed-services-support",
      },
      {
        text: "Support Models",
        path: "/services/managed-services/support-models",
      },
    ],
    cards: [
      {
        img: "/images/smcard1.webp",
        alt: "Salesforce support growth",
        title: "Seamless Salesforce Support for Business Growth",
        path: "/services/manages-services/managed-services-support",
      },
      {
        img: "/images/smcard2.webp",
        alt: "Salesforce support models",
        title: "Our Salesforce Support Models ",
        path: "/services/manages-services/managed-services-support",
      },
      {
        img: "/images/smcard3.webp",
        alt: "Flexible engagement options",
        title: "Flexible Engagement Options to Match Your Business Needs",
        path: "/services/manages-services/support-models",
      },
      {
        img: "/images/smcard4.webp",
        alt: "Tailored Salesforce support models",
        title: "Tailored Salesforce Support Models for Flexibility",
        path: "/services/manages-services/support-models",
      },
    ],
  },
  {
    text: "Training & User Adoption",
    img: training,
    path: "/services/training-user-adoption",
  },
  {
    text: "Salesforce Org Assessment",
    img: org_assessment_icon,
    path: "/services/salesforce-org-assessment",
  },
];
